import {
  Avatar,
  Button,
  Drawer,
  Form,
  List,
  Modal,
  Select,
  Skeleton,
  Space,
} from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../context";
import { DeleteOutlined } from "@ant-design/icons";
import LOGO from "./../../../assets/tinyimg/logo.webp";

const DisplayMerchantsConnection = ({ open, close, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const { userData } = useContext(UserInfo);
  const [initLoading, setInitLoading] = useState(true);
  const [addMerchant, setAddMerchant] = useState(false);
  const [merchantList, setMerchantList] = useState({
    data: [],
    ready: false,
  });
  const [merchantConnection, setMerchantConnection] = useState({
    data: [],
    ready: false,
  });
  const [tableData, setTableData] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const getAllMerchantsConnection = () => {
    var params = { user_id: selectedData.user_id };
    axios
      .get("user/admin/get/spec-store-admin/merchant-list", { params })
      .then((response) => {
        const data = response.data;
        setMerchantConnection({ data, ready: true });
        setInitLoading(false);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const getMerchantList = () => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/admin/merchant-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getAllMerchantsConnection();
    getMerchantList();
  }, [selectedData]);

  const handleAddMerchant = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", selectedData.user_id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setInitLoading(true);
    axios
      .post("user/admin/create/spec-store-admin/merchant-list", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Added merchant successfully.");
          setTimeout(() => {
            setAddMerchant(false);
            getAllMerchantsConnection();
          }, 1000);
        }
        if (data === "merchant-exist") {
          rerunNotif("error", "Merchant already added.");
          setAddMerchant(false);
          setInitLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setOpenDelete(false);
      setConfirmLoading(false);
      handleRemoveStoreAdmin();
    }, 2000);
  };

  const handleRemoveStoreAdmin = () => {
    const formdata = new FormData();
    formdata.append("id", tableData.id);
    setInitLoading(true);
    axios
      .post("user/admin/remove/store-admin/spec-merchant", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Removed merchant successfully.");
          setTimeout(() => {
            getAllMerchantsConnection();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  return (
    <Drawer
      title="Merchant List"
      width={window.innerWidth > 500 ? 500 : window.innerWidth}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
      extra={
        <Space>
          <Button
            type="primary"
            onClick={() => {
              setAddMerchant(true);
            }}
          >
            Add merchant
          </Button>
        </Space>
      }
    >
      {/* {console.log("tableData", tableData)} */}
      <List
        className="demo-loadmore-list"
        loading={initLoading}
        itemLayout="horizontal"
        //   loadMore={loadMore}
        dataSource={merchantConnection.data}
        renderItem={(item, index) => (
          <List.Item
            actions={[
              <DeleteOutlined
                style={{ cursor: "pointer", color: "red", fontSize: 18 }}
                onClick={() => {
                  setTableData(item);
                  setOpenDelete(true);
                }}
              />,
            ]}
          >
            <Skeleton avatar title={false} loading={item.loading} active>
              <List.Item.Meta
                avatar={
                  <Avatar
                    src={
                      item.branchmerchant.business_logo !== null
                        ? `${import.meta.env.VITE_API_IMAGE}logo/${
                            item.branchmerchant.business_logo
                          }`
                        : LOGO
                      // `https://xsgames.co/randomusers/avatar.php?g=pixel&key=${index}`
                    }
                  />
                }
                title={`${item.branchmerchant.business_name} - ${item.branchmerchant.reg_firstname} ${item.branchmerchant.reg_lastname}`}
                description={
                  <span style={{ textTransform: "lowercase" }}>
                    {`${
                      item.branchmerchant.business_street !== null
                        ? `${item.branchmerchant.business_street}, `
                        : ""
                    }
                ${
                  item.branchmerchant.business_barangay !== null
                    ? `${item.branchmerchant.business_barangay}, `
                    : ""
                }
                ${
                  item.branchmerchant.business_city !== null
                    ? `${item.branchmerchant.business_city}, `
                    : ""
                }
                ${
                  item.branchmerchant.business_province !== null
                    ? `${item.branchmerchant.business_province}`
                    : ""
                }
                `}
                  </span>
                }
              />
              {/* <div>content</div> */}
            </Skeleton>
          </List.Item>
        )}
      />

      <Modal
        title=""
        open={addMerchant}
        onCancel={() => setAddMerchant(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="add-merchant"
          onFinish={handleAddMerchant}
          autoComplete="off"
          style={{ marginTop: 20 }}
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="merchant_id"
              label="Merchant"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select merchant"
                // onChange={handleGetCityByProvince}
                size="large"
                // showSearch
                // filterOption={(input, option) =>
                //   option.props.children
                //     .toLowerCase()
                //     .indexOf(input.toLowerCase()) >= 0
                // }
              >
                {merchantList.data.length > 0 ? (
                  merchantList.data.map((data, index) => (
                    <Select.Option
                      value={data.id}
                      key={index}
                      disabled={
                        merchantConnection.data.find(
                          (item) => item.branchmerchant.user_id === data.user_id
                        )
                          ? true
                          : false
                      }
                    >
                      {data.business_name} - {data.reg_firstname}{" "}
                      {data.reg_lastname}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No province found!</Select.Option>
                )}
              </Select>
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "0px" }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "100%", borderRadius: "10px" }}
            >
              Add
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Are you sure to delete this merchant on the list?"
        open={openDelete}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setOpenDelete(false)}
        centered
        width={350}
      />
    </Drawer>
  );
};

export default DisplayMerchantsConnection;
